import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { authApiService } from "../../../api/api";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/modal/delete.svg";
import { IProductType } from "../../../types/productType.type";
import DefaultModal from "../DefaultModal/DefaultModal";
import ModalDeleteButtons from "../forms/buttons/ModalDeletButtons/ModalDeleteButtons";
import EditProductTypeForm from "../forms/EditProductTypeForm/EditProductTypeForm";
import ViewProductTypeForm from "../forms/EditProductTypeForm/ViewProductTypeForm";
import ModalTitle from "../ModalTitle/ModalTitle";
import styles from "./styles.module.scss";

interface Props {
  type: IProductType;
  onClose: () => void;
  onApply: () => void;
  isInfo: boolean;
}

const EditProductTypeModal: React.FC<Props> = (props) => {
  const [isEdit, setIsEdit] = useState<boolean>(!props.isInfo);
  const [isDelete, setIsDelete] = useState<boolean>(false);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        props.onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.onClose]);

  const onPressApply = async () => {
    props.onApply();
    props.onClose();
  };

  const onPressDelete = async () => {
    try {
      const response = await authApiService.deleteProductType(props.type.id);
      if (response) {
        props.onApply();
        props.onClose();
      }
    } catch (err: any) {
      console.error(err.message);
      if (
        err.response.data.message ===
        "Cannot delete provider with associated resources."
      ) {
        toast.error("Не можливо видалити, якщо є повʼязаний з ним ресурс.");
      }
    }
  };

  return (
    <DefaultModal>
      <div className={styles.container}>
        {isDelete ? (
          <>
            <ModalTitle
              onClose={props.onClose}
              title="Підтвердіть видалення тику"
              subTitle="Ви дійсно хочете видалити цей тип? Цю дію неможливо скасувати."
            >
              <DeleteIcon />
            </ModalTitle>
            <ModalDeleteButtons
              onPressApply={onPressDelete}
              onPressBack={() => {
                setIsDelete(false);
              }}
              applyTitle="Видалити"
              backTitle="Назад"
            />
          </>
        ) : isEdit ? (
          <>
            <ModalTitle
              onClose={props.onClose}
              title="Редагувати тип"
              subTitle='Редагуйте інформацію. Внесіть необхідні зміни та натисніть "Зберегти".'
            ></ModalTitle>
            <EditProductTypeForm
              onApply={onPressApply}
              onClose={() => setIsDelete(true)}
              type={props.type}
            />
          </>
        ) : (
          <>
            <div className={styles.header}>
              <div className={styles.nameContainer}>
                <span className={styles.name}>{props.type.name}</span>
              </div>
            </div>
            <ViewProductTypeForm
              onClose={props.onClose}
              onPressEdit={() => setIsEdit(true)}
              type={props.type}
            />
          </>
        )}
      </div>
    </DefaultModal>
  );
};

export default EditProductTypeModal;
